// extracted by mini-css-extract-plugin
export default {"icon":"Links_icon__2UoAu","link":"Links_link__tWric","text":"Links_text__pxuRh"};